import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../../../services/auth";
import { formatAddressLine } from "../../../helpers/helpers";
import api from "../../../services/api";
import { ModalDelete } from "../../ModalDelete";
import ModalCreateAddress from "../../ModalCreateAddress";
import Button from "../../Button";
import Table from "../../Table";
import { renderError } from "../../../helpers/errors";


const AddressTab = ({type, company, customer, onAddressUpdated}) => {
    const navigate = useNavigate();

    const entity = company || customer;
    const entityName = company ? 'company' : 'customer';

    const [loading, setLoading] = useState(false);
    const [showCreate, setShowCreate] = useState(false);

    const [addressToDelete, setAddressToDelete] = useState(null);
    const [addressToEdit, setAddressToEdit] = useState(null);

    const header = ['Endereço', 'Padrão'];
    const rows = [];
    
    if(hasPermission(`edit_${entityName}`)){
        header.push('');
    }

    entity.addresses.map(address => {
        if(address.type !== type || address.from_company || address.from_customer) return;

        let data = {
            data: [address.formatted_address, address.is_default ? 'Padrão' : '']
        };

        if(hasPermission(`edit_${entityName}`)){
            data.action = () => setAddressToEdit(address);
            data.buttons = [
                <Button type={`delete`} svg={`delete`} action={() => setAddressToDelete(address.id)} />
            ];
        }

        rows.push(data);
    });

    const deleteAddress = () => {
        setLoading(true);
        api.delete(`/${entityName}/${entity.id}/address/${addressToDelete}`).then(res => {
            setAddressToDelete(null);
            onAddressUpdated();
        }).catch(error => {
            setLoading(false);
            renderError(error);
        });
    }

    return (
        <>
            <ModalDelete 
                show={addressToDelete !== null}
                action={deleteAddress}
                loading={loading}
                close={() => setAddressToDelete(null)}
            />
            <ModalCreateAddress 
                type={type}
                show={!!addressToEdit} 
                companyId={company?.id ?? null}
                customerId={customer?.id ?? null}
                address={addressToEdit}
                close={() => {
                    setAddressToEdit(null)
                }}
                onAddressStored={() => onAddressUpdated()}
            />
            <ModalCreateAddress 
                type={type}
                show={showCreate} 
                companyId={company?.id ?? null}
                customerId={customer?.id ?? null}
                close={() => {
                    setShowCreate(false)
                }}
                onAddressStored={() => onAddressUpdated()}
            />
            {hasPermission('edit_company') &&
                <Button type={`secondary`} size={`small`} text={`Adicionar endereço`} svg={`plus-blue`} action={() => setShowCreate(true)} />
            }
            <br />
            <Table header={header} rows={rows} loading={loading} />
        </>
    );
}

export default AddressTab;